export default __webpack_public_path__ + "static/media/1461.d8900afc.png";